import React, { useRef, useEffect, useState, useCallback } from 'react';
import ChatMessage from './components/ChatMessage';
import WelcomeScreen from './components/WelcomeScreen';
import TypingIndicator from './components/TypingIndicator';
import { useWebSocket } from './hooks/useWebSocket';
import { LOGOS, INPUT_PLACEHOLDER, DISCLAIMER } from './config';
import './App.css';
import Avatar from './components/Avatar';
import KeycloakWelcome from './KeyclockWelcome';
import { useKeycloak } from "@react-keycloak/web"
import LoadingSpinner from './components/LoadingSpinner';
import AccessDeniedModal from './components/AccessDeniedModal';
import axios from "axios";
import SourcePanel from './components/SourcePanel';
function SendIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="19" x2="12" y2="5" />
      <polyline points="5 12 12 5 19 12" />
    </svg>
  );
}

function AppContent() {
 const { keycloak } = useKeycloak();
   const { status, messages, isTyping, sendMessage, clearMessages, STATUS, chat_widget_icon, data_assistant_icon } = useWebSocket();
  const [text, setText] = useState('');
  const [sourcePanel, setSourcePanel] = useState(null);
  const messagesEndRef = useRef(null);
  const textareaRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isTyping]);

  useEffect(() => {
    const ta = textareaRef.current;
    if (!ta) return;
    ta.style.height = 'auto';
    ta.style.height = Math.min(ta.scrollHeight, 160) + 'px';
  }, [text]);

  const handleOpenSourceFile = useCallback((files, index) => {
    setSourcePanel({ files, activeIndex: index });
  }, []);

  const handleCloseSourcePanel = useCallback(() => {
    setSourcePanel(null);
  }, []);

  const handleChangeSourceFile = useCallback((index) => {
    setSourcePanel((prev) => prev ? { ...prev, activeIndex: index } : prev);
  }, []);

  const handleSend = useCallback(() => {
    const trimmed = text.trim();
    if (!trimmed || isTyping) return;
    sendMessage(trimmed);
    setText('');
    if (textareaRef.current) textareaRef.current.style.height = 'auto';
  }, [text, isTyping, sendMessage]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
  const statusColor = {
    [STATUS.CONNECTED]: '#22c55e',
    [STATUS.CONNECTING]: '#f59e0b',
    [STATUS.DISCONNECTED]: '#d1d5db',
    [STATUS.ERROR]: '#ef4444',
  }[status] || '#d1d5db';

  const statusLabel = {
    [STATUS.CONNECTED]: 'Connected',
    [STATUS.CONNECTING]: 'Connecting…',
    [STATUS.DISCONNECTED]: 'Disconnected',
    [STATUS.ERROR]: 'Connection error',
  }[status] || '';

  const logout_url = window.location.href;
   console.log(logout_url,'logout_url');
   
  const logoutUser = () => {
    keycloak.logout({ redirectUri: logout_url });
  };


  return (
    <div className="app">
      <header className="app-header">
        <div className="header-logo">
          <Avatar
            src={chat_widget_icon || data_assistant_icon || LOGOS.logo}
            alt="Arya"
            className="header-logo-img"
          />
        </div>

        <div className="header-right">
          <span className="status-dot" style={{ background: statusColor }} title={statusLabel} />
          <span className="header-status-label">{statusLabel}</span>
          {messages.length > 0 && (
            <button className="clear-btn" onClick={clearMessages}>New chat</button>
          )}
           <div style={{ maxWidth:"93px",justifyContent:"center",display:"flex",cursor:"pointer",marginLeft:"13px" }} onClick={()=>logoutUser()}>
         <img src='/logos/logout.png' alt='logout' style={{ height:"14px",width:"14px" ,marginRight:"3px",marginTop:"2px"}}/>
          <p style={{ color:"red",fontWeight:"bold" }}>Logout</p>
        </div>
        </div>
      </header>

      <main className="chat-main">
        <div className="messages-scroll">
          <div className="messages-container">
            {messages.length === 0 ? (
              <WelcomeScreen
                chat_widget_icon={data_assistant_icon}
                statusLabel={statusLabel}
              />
            ) : (
              <>
                {messages.map((msg, idx) => (
                  <ChatMessage
                    key={msg.id}
                    message={msg}
                    chat_widget_icon={data_assistant_icon}
                    isLast={idx === messages.length - 1}
                    onFollowUp={(q) => { sendMessage(q); }}
                     onOpenSourceFile={handleOpenSourceFile}
                  />
                ))}
                {isTyping && <TypingIndicator chat_widget_icon={data_assistant_icon}/>}
                <div ref={messagesEndRef} />
              </>
            )}
          </div>
        </div>

        <div className="input-area">
          <div className="input-inner">
            <div className="input-box">
              <textarea
                ref={textareaRef}
                className="chat-textarea"
                placeholder={INPUT_PLACEHOLDER}
                value={text}
                rows={1}
                onChange={(e) => setText(e.target.value)}
                onKeyDown={handleKeyDown}
                disabled={isTyping}
              />
              <button
                className={`send-btn ${text.trim() && !isTyping ? 'active' : ''}`}
                onClick={handleSend}
                disabled={!text.trim() || isTyping}
                title="Send (Enter)"
              >
                <SendIcon />
              </button>
            </div>
            <p className="input-hint">
              {DISCLAIMER}
            </p>
          </div>
        </div>
      </main>
      
      <SourcePanel
        isOpen={sourcePanel !== null}
        files={sourcePanel?.files || []}
        activeIndex={sourcePanel?.activeIndex || 0}
        onChangeFile={handleChangeSourceFile}
        onClose={handleCloseSourcePanel}
      />
    </div>
  )
}
export default function App() {
  const { keycloak, initialized } = useKeycloak();
  const [showAccessDenied, setShowAccessDenied] = useState(false);
 const [orgCheckStatus, setOrgCheckStatus] = useState("idle"); 
  // Read the org code from the URL once on mount
  const ORG_CODE = window.location.pathname.split("/").filter(Boolean)[0] || null;
  const ac_id = window.location.pathname.split("/").filter(Boolean)[1] || null;
 
  let env = {};
let envsLocal = {
  REACT_APP_WS_BASE_HOST: process.env.REACT_APP_WS_BASE_HOST,
};
const getEnv = () => {
    if (process.env.NODE_ENV === "development") {
        return (env = envsLocal);
    } else {
        return (env = window._env_);
    }
};

getEnv();
   function getInitiateChatbotUrl(wsUrl) {
    const url = new URL(wsUrl);

    url.protocol = url.protocol === "wss:" ? "https:" : "https:";

    url.pathname = url.pathname.replace(
      "/arya_socket/chatbot-ws-stream",
      "/initiate_chatbot",
    );
    return url.toString();
  }

  const apiUrl = getInitiateChatbotUrl(env.REACT_APP_WS_BASE_HOST)+`/api/v1/clarity/clarity_dc/checkValidOrg?org_code=${ORG_CODE}&ac_id=${window.atob(ac_id)}`;
 
  
  useEffect(() => {
    if (!ORG_CODE) {
      setShowAccessDenied(true);
    }
  }, [ORG_CODE]);
 
  // Gate 2: org code is present, but is it actually valid?
  useEffect(() => {
    if (!ORG_CODE || !initialized || !keycloak.authenticated) return;
 
    let cancelled = false;
    setOrgCheckStatus("checking");
 
    axios
      .get(apiUrl,{ headers: { Authorization: `Bearer ${keycloak.token}` } })
      .then((res) => {
        if (cancelled) return;
        if (res.data?.status === true || res.data?.status === "true") {
          setOrgCheckStatus("valid");
        } else {
          setOrgCheckStatus("invalid");
          setShowAccessDenied(true);
        }
      })
      .catch(() => {
        if (cancelled) return;
        // Fail closed: if we can't confirm the org is valid, treat it as denied
        setOrgCheckStatus("invalid");
        setShowAccessDenied(true);
      });
 
    return () => {
      cancelled = true;
    };
  }, [ORG_CODE, initialized, keycloak.authenticated]);
 
  const handleLogout = () => {
    keycloak.logout();
  };
 
  if (!initialized) {
    return <LoadingSpinner />;
  }
 
  if (!keycloak.authenticated) {
    return <KeycloakWelcome />;
  }
 
  // No org code in the URL
  if (!ORG_CODE) {
    return (
      <AccessDeniedModal
        open={showAccessDenied}
        onLogout={handleLogout}
        title="No organization found"
        message="We couldn't find an organization in this URL. Log out and try again, or check the link you used to get here."
        hideGoBack
      />
    );
  }
 
  // Org code present but not yet confirmed valid — keep it quiet, no flash of AppContent
  if (orgCheckStatus === "idle" || orgCheckStatus === "checking") {
    return <LoadingSpinner />;
  }
 
  // Org code present but failed validation against the API
  if (orgCheckStatus === "invalid") {
    return (
      <AccessDeniedModal
        open={showAccessDenied}
        onLogout={handleLogout}
        title="Organization not found"
        message="This organization couldn't be verified. Log out and try again, or check the link you used to get here."
        hideGoBack
      />
    );
  }
 
  return <AppContent />;
}
